import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-types-papi';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import {
  getProfileOwner,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
  isViewingAsVisitor,
} from '../../../../../selectors/users';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
  viewProfileAsVisitor,
} from '../../../../../actions/profileOwner';
import { Props } from './MoreActionsDropdownMobile';

type StateProps = Pick<
  Props,
  'giveState' | 'profileOwnerUser' | 'isOwner' | 'canViewAsVisitor'
>;
type DispatchProps = Pick<
  Props,
  | 'pushBadgeModal'
  | 'pushPointsModal'
  | 'initGiveState'
  | 'onLlamaBadgeSent'
  | 'onCakeBadgeSent'
  | 'viewAsVisitor'
  | 'pushBlockModal'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  giveState: getProfileOwner(state).giveState!,
  profileOwnerUser: getProfileOwnerUser(state),
  isOwner: isCurrentUserProfileOwner(state),
  canViewAsVisitor: !isViewingAsVisitor(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  pushBadgeModal: (name, userId, title, onBadgeSent) =>
    dispatch(modalActions.pushBadgeModal(name, userId, title, '', onBadgeSent)),
  pushPointsModal: (userId, title) =>
    dispatch(modalActions.pushPointsModal(userId, title)),
  initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
  onLlamaBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
  onCakeBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
  viewAsVisitor: () => dispatch(viewProfileAsVisitor(true)),
  pushBlockModal: (profileOwner: PapiUser) =>
    dispatch(
      pushModal(ModalType.USER_BLOCK, {
        wrapInPopup: true,
        params: {
          user: profileOwner,
          redirectLocation: Url.browseHomeLink(),
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
